export interface ScrollWindow {
  scrollLeft: number;
  width: number;
}

export interface ScrollItem {
  left: number;
  width: number;
}

/** The scrollLeft that shows the whole item with `inset` px clear of each edge, or the current one if it already does. */
export function scrollLeftToReveal(view: ScrollWindow, item: ScrollItem, inset: number): number {
  const start = item.left - inset;
  const end = item.left + item.width + inset;
  if (start < view.scrollLeft || end - start > view.width) return Math.max(0, start);
  if (end > view.scrollLeft + view.width) return end - view.width;
  return view.scrollLeft;
}
